import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { ReactSession } from 'react-client-session';
import { useParams } from 'react-router-dom';
import useWeb3 from '../../hooks/useWeb3';

function Ref() {
 
  const { account } = useWallet();

   const { refaddr } = useParams();

   const web3 = useWeb3();
   
  
      if(!web3.utils.isAddress(refaddr)){
        ReactSession.set("refwallet","0x0000000000000000000000000000000000000000"); 
       }else if(refaddr == '0x000000000000000000000000000000000000dEaD'){
         ReactSession.set("refwallet","0x0000000000000000000000000000000000000000"); 
       }else{
        ReactSession.set("refwallet",refaddr); 
       }
   

       window.location='/';
    
     return ( 
      <>
        
      </> 
  ); 

} 

export default Ref;